import { FC } from 'react';
import AboutPage from '@/modules/landing/pages/about/about-page.component';

const AboutPageIndex: FC = AboutPage;

export default AboutPageIndex;
